module.exports = __webpack_public_path__ + "img/3-3.4f443887.png";